// extracted by mini-css-extract-plugin
export default {"paper":"_3ucRzpeqd6AMnDpjuwyaWz","actionButtons":"jmEmTGMlRpCsHnTDE9ob0"};